import React from 'react'

const ProductsSubcategory: React.FC = () => (
  <svg width="72" height="73" viewBox="0 0 72 73" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.53846" width="72" height="72" rx="14.5455" fill="url(#paint0_linear_4461_1540)" />
    <path
      d="M30.6409 42.0507C30.4063 38.3569 28.4129 35.7185 25.4227 33.725C25.4813 33.6664 25.5399 33.5491 25.5986 33.4905C26.6539 32.3765 27.7093 31.2625 28.7647 30.2071C28.8819 30.0899 29.1165 30.0312 29.2923 29.9726C31.7549 29.7967 33.807 30.8521 35.5073 32.5524C36.2695 33.3146 36.9144 34.1354 37.618 34.8977C37.7353 33.8423 36.9144 31.497 36.035 30.1485C35.0382 28.7414 33.807 27.5687 32.3412 26.6306C32.3998 26.572 32.3998 26.5134 32.4584 26.5134C34.1001 25.458 35.7418 24.344 37.3835 23.2886C37.6766 23.1127 37.9698 23.1127 38.3216 23.23C40.1978 23.6991 41.6049 24.8131 42.8362 26.1616C43.3639 26.6893 43.7743 27.2756 44.302 27.8619C44.3606 27.9791 44.4779 28.0378 44.6538 28.2723C44.3606 25.6339 43.4225 23.4645 41.5463 21.7642C41.5463 21.7056 41.5463 21.647 41.5463 21.647C42.4844 21.4711 43.4225 21.2365 44.4193 21.1193C45.5919 20.9434 46.8231 21.0606 47.9371 21.4124C50.0479 22.0574 51.1619 23.5818 51.5137 25.6925C51.8654 27.8033 51.455 29.7967 50.8101 31.7902C49.6374 35.1322 47.7612 38.1224 45.4746 40.8194C42.3085 44.6305 38.6147 47.7966 34.1588 50.0246C32.1653 51.0213 30.0546 51.7835 27.7679 52.018C26.5367 52.0767 25.4813 52.018 24.4259 51.7249C22.1979 51.1386 20.7322 49.4382 20.439 47.093C20.1458 44.8064 20.6735 42.637 21.4944 40.5263C21.9634 39.4123 22.5497 38.3569 23.0188 37.2429C23.136 37.0084 23.2533 36.9498 23.5465 37.0084C25.4813 37.1843 27.0644 38.0637 28.3542 39.4123C29.1165 40.2331 29.82 41.1712 30.6409 42.0507Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4461_1540"
        x1="35.5325"
        y1="0.538462"
        x2="91.0286"
        y2="43.7385"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6600E8" />
        <stop offset="1" stopColor="#BD0044" />
      </linearGradient>
    </defs>
  </svg>
)

export default ProductsSubcategory
